window.Gesture = function() {
	
	var 

	gesture = {start:[], move:[], end:[]},


	getAllTouches = function(e) {
		var touches = e.changedTouches.length < 2 && e.touches.length >=2 ? e.touches : e.changedTouches,
		points = [];
	 
		function Point(touch) {
			return {
				x: touch.clientX,
				y: touch.clientY 
			};
		}

		if(!touches) {
			return points;
		}

		for (var i = 0; i < touches.length; i++) {
			var touch = touches[i];

			points.push(Point(touch));
		}

		
		return points;
	},

	getAllPointers = function(pointerArr) {
		var points = [];
	 
		function Point(touch) {
			return {
				x: touch.clientX,
				y: touch.clientY 
			};
		}

		if(!pointerArr) {
			return points;
		}

		for (var i = 0; i < pointerArr.length; i++) {
			var touch = pointerArr[i];

			points.push(Point(touch));
		}

		
		return points;
	},

	getGesturePointFromEvent = function(e) {
		var touches = e.targetTouches;

		return {
			x: touches ? touches[0].clientX : e.clientX,
			y: touches ? touches[0].clientY : e.clientY
		};
	},

	setEvents = function(start, move, end) {
		gesture.start.push(start);
		gesture.move.push(move);
		gesture.end.push(end);
	},

	/**
	 * Setup Event Names and other initial values.
	 */
	getGestureSupport = function() {

		var 

		  pE = false//window.PointerEvent // needs more work in order to start working with pointerevent
		, pointers = (pE || window.navigator.msPointerEnabled) ? true : false
		, touches = 'ontouchstart' in window ? true : false

		// Touch or Pointer
		, start = pointers ? pE ? 'pointerdown' : 'MSPointerDown' : touches ? "touchstart" : 0
		, move = pointers ? pE ? 'pointermove' : 'MSPointerMove' : touches ? "touchmove" : 0
		, end = pointers ? pE ? 'pointerup' : 'MSPointerUp' : touches ? "touchend" : 0
		;

		// Setup Touch Event Listeners
		setEvents(start, move, end);

		if(touches) gesture.end.push("touchcancel"); 

		// Setup Mouse Event Listeners
		setEvents("mousedown", "mousemove", "mouseup");

		// Bind or Unbind Event Listeners
		gesture.bind = function(on, el, eventsArray, callback) {

			for (var i = 0; i < eventsArray.length; i++) {
				if (!on) {
					el.removeEventListener(eventsArray[i], callback);
				}else{
					el.addEventListener(eventsArray[i], callback);
				}
			}
		};

		return gesture;
	};

	return {
		getGestureSupport: getGestureSupport,
		getGesturePointFromEvent: getGesturePointFromEvent,
		getAllTouches: getAllTouches,
		getAllPointers: getAllPointers
	}
}

document.ondragstart = function () { return false; };

var ges = Gesture();
var touch = ges.getGestureSupport();